// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"style_modalBody__Nw_70","modalWrapper":"style_modalWrapper__1unGm","operateArea":"style_operateArea__t_oq0","closeButton":"style_closeButton__8iczI"};